import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyDetailMaster } from '../model/CompanyDetailMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  companyDetailMaster:CompanyDetailMaster = new CompanyDetailMaster();

  constructor(private authService:AuthService,private router:Router,private mainService:MainserviceService, private meta: Meta,private titleService: Title) {
    this.meta.updateTag({ name: 'description', content: "Contact us for any queries related to our Online Programs, Certificate Modules, Enrollment & Application Process, or just to talk to us. Reach us on Phone, Email, WhatsApp." }); 
    titleService.setTitle("Contact Us | Edstate"); 
   }

  ngOnInit() {
    this.getCompanyDetail();
  }




  getCompanyDetail(): any {
    // this.spinnerService.show();
  
    this.mainService.getCompanyDetail(new CompanyDetailMaster()).subscribe(
      data => {
        this.companyDetailMaster = data;
        // this.spinnerService.hide();
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
         //   this.spinnerService.hide();
            let data = JSON.parse(jsonString);
            this.companyDetailMaster = data;
          } else {
            this.authService.showMessage('error','Something went wrong', '');
          //  this.spinnerService.hide();
          }
          // this.spinnerService.hide();
        }
      }
    );
  }

}
